module.exports = __webpack_public_path__ + "static/media/checked.e785b125.svg";